import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../../../utility/client';

export const getBasestationHistory = async (basestationId: string) => {
  const res = await Api.get<AdminTypes.BasestationHistory[]>(
    `/admin/v1/basestations/${basestationId}/history`,
  );

  return res.data;
};
